var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgF3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5685 0H11.7405C11.7405 0 11.7405 0 11.7365 0H1.22001C0.544937 0 0 0.544937 0 1.22001C0 11.6795 3.11102 17.804 9.50793 19.939C9.63399 19.9797 9.76413 20 9.89426 20C10.0244 20 10.1545 19.9797 10.2806 19.939C16.6816 17.804 19.7885 11.6795 19.7885 1.22001C19.7885 0.544937 19.2436 0 18.5685 0ZM2.45222 2.44002H9.82513L6.96218 8.82066C6.79138 9.19886 6.82798 9.634 7.05165 9.98373C7.27531 10.3294 7.66165 10.5409 8.07645 10.5409H10.4311L7.79992 16.401C4.35543 14.0626 2.62708 9.54046 2.45222 2.44002ZM10.0081 17.438L13.4282 9.817C13.599 9.4388 13.5624 9.00366 13.3388 8.65392C13.1151 8.30826 12.7288 8.09679 12.3139 8.09679H9.95933L12.501 2.43595H17.3363C17.133 10.7849 14.7824 15.5836 10.0081 17.4339V17.438Z",
    fill: "#ba120e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF3);
export default __webpack_public_path__ + "static/media/f3.73216508c5c46efbf86dd384664cd36c.svg";
export { ForwardRef as ReactComponent };